import React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n/config';
import reportWebVitals from './reportWebVitals';

const suppressedWarnings = ['ResizeObserver loop completed with undelivered notifications'];

const originalConsoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && suppressedWarnings.some((warning) => args[0].includes(warning))) {
    return;
  }
  originalConsoleError(...args);
};

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
